import endpoints from '@/utils/constants';
import { apiHelper, authHelper } from '@/utils/helpers';

const actions = {
    saveServiceCategory(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('post', `${endpoints.BASE_URL}${endpoints.API.serviceCategories}`, context.state.serviceCategory).then((res) => {
                if (res.status === 201) {
                    resolve(res.data)
                }
            }).catch(err => {
                reject(err)
            })
        })

    },

    getServiceCategoryList(context, query) {
        const url = new URL(`${endpoints.BASE_URL}${endpoints.API.serviceCategories}`);
        if (query) {
            url.search = new URLSearchParams(query);
        }
        return new Promise((resolve, reject) => {
            apiHelper.call('get', url).then((res) => {
                if (res.status === 200) {
                    context.commit('setServiceCategoryList', res.data);
                    resolve(res.data)
                }
            }).catch(err => {
                reject(err);
            })
        })
    },

    fetchServiceCategory(context, serviceCategoryId) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.serviceCategories}/${serviceCategoryId}`).then((res) => {
                if (res.status === 200) {
                    resolve(res.data);
                }
            }).catch(err => {
                reject(err);
            })
        })
    },

    updateServiceCategory(context) {
        return new Promise((resolve, reject) => {
            apiHelper.call('put', `${endpoints.BASE_URL}${endpoints.API.serviceCategories}/${context.state.serviceCategory.serviceCategoryId}`, context.state.serviceCategory).then((res) => {
                if (res.status === 200) {
                    context.commit('setServiceCategory', res.data);
                    resolve(res);
                }
            }).catch(err => {
                reject(err);
            })
        });
    },

    getNestedServiceCategories(_) {
        return new Promise((resolve, reject) => {
            apiHelper.call('get', `${endpoints.BASE_URL}${endpoints.API.serviceCategories}/nested/list`)
                .then(res => {
                    if(res.status === 200) {
                        resolve(res.data)
                    }
                }).catch(err => {
                    reject(err)
                })
        })
    }


}
export default actions;